import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { FusePageCarded } from '@fuse';
import LessonForm from './LessonForm';
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as Actions from './store/actions';
import * as courseActions from '../course/store/actions';
import ModelAssetList from '../asset/ModelAssetList';
import LessonSchedule from './LessonSchedule'
import DetailSchedule from './ScheduleComponents/DetailSchedule';
import moment from 'moment'
import { Button, Tab, Tabs, Grid, Divider, DialogTitle, DialogContent, DialogActions, Dialog, Typography, Tooltip, Icon, TextField } from '@material-ui/core';
import * as validatorActions from '../../components/validator/store/actions';
import * as paramActions from '../../components/paramHistory/store/actions';
import LessonEventList from './LessonEventList';
import CourseBuilderHeader from '../../components/CourseBuilderHeader';
import TabPanelButtons from '../../components/TabPanelButtons';
import UnscheduledLesson from './ScheduleComponents/UnscheduledLesson';
import PageHeader from 'main/components/PageHeader';
import RelationUpdateTabs from '../../components/RelationUpdateTabs';
import StaticRelationList from '../../components/StaticRelationList';
import { getSharedTextFieldProps } from '../../components/helpers';
import _ from 'lodash';

const styles = theme => ({
    layoutRoot: {
        
    },
    layoutToolbar: {
        padding: 0,
    },
    tabsRoot: {
        height: 64,
        flex: 1
    },
    tabRoot: {
        height: 64,
        [theme.breakpoints.up('md')]: {
            minWidth: '144px'
        }
    },
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: '80%',
    },
    textFieldSearch: {
        marginLeft: theme.spacing.unit,
        width: '95%',
    },
    button: {
        margin: theme.spacing.unit,
        minWidth: '80%',
        maxWidth: '80%'
    },
    test: {
        marginTop: '50px'
    }
});

class Lesson extends Component {
    state = {
        current_tab: 0,
        lesson_id: 0,
        view_type: '',
        tabValue: 0,
        deleteDialogActive: false,
        lockDialogActive: false,
        unlockDialogActive: false,
        activateDialogActive: false,
        copyDialogActive: false
    }

    constructor(props) {
        super(props);
        const lesson_id = this.props.match.params.lesson_id;
        const view_type = this.props.match.params.view_type;

        this.state = {
            ...this.state,
            lesson_id: lesson_id,
            view_type: view_type,
        }

        if (props.paramHistory.active && view_type != 'create' && props.paramHistory.courseUnscheduled === 0) {
            this.state = {
                ...this.state,
                current_tab: 2
            }
        }

        if (props.paramHistory.active && view_type != 'create' && props.paramHistory.courseUnscheduled === 1) {
            this.state = {
                ...this.state,
                current_tab: 3
            }
        }

        this.props.updateLessonLoaded(false);
        if (view_type !== 'create') {
            this.props.getLessonData(lesson_id);
        } else {
            this.props.updateLessonLoaded(true);
            this.props.getAllAssignments();
            this.props.getAllQuizzes();
            this.props.getCompanyList();
        }
        const validationList = [
            {
                field_name: 'LessonName', functionName: ['checkRequiredFilled']
            }
        ]

        this.props.startValidator(validationList)
    }

    componentDidUpdate = (prevProps) => {
        // This resets the page if you go to a different lesson_id
        if (this.props.paramHistory.lessonCycleRedirect || (!_.isEqual(parseInt(this.props.match.params.lesson_id), this.props.currentLesson.lesson_id)) && this.props.repullLesson ) {
            this.setState({
                ...this.state,
                lesson_id: this.props.match.params.lesson_id,
                copyDialogActive: false
            });
            this.props.updatePageHeader({ lessonCycleRedirect: false })
            this.props.updateLessonLoaded(false);
            this.props.getLessonData(this.props.match.params.lesson_id);

            const validationList = [
                {
                    field_name: 'LessonName', functionName: ['checkRequiredFilled']
                }
            ]

            this.props.startValidator(validationList)
        }

    }

    handleLockDialogOpen = () => {
        this.setState({ lockDialogActive: true });
    }

    handleUnlockDialogOpen = () => {
        this.setState({ unlockDialogActive: true });
    }

    handleChangeTab = (event, value) => {
        this.setState({
            ...this.state,
            current_tab: value
        })
    }

    handleCompanySearchChange = (e) => {
        this.props.companyUpdateSearch(e.target.value)
    }

    handleChangeIndex = index => {
        this.setState({ value: index });
    };

    handleSubmit = () => {
        const auth_id = this.props.auth.user.data.auth_id;
        const paramHistory = this.props.paramHistory
        const paramActive = paramHistory.active

        switch (this.state.view_type) {
            case ("create"):
                {
                    this.props.updateLessonListLoaded(false);
                    if (paramActive) {
                        this.props.updatePageHeader({ LessonName: '' })
                        this.props.saveLesson(this.props.currentLesson, this.props.currentLessonAssignmentList, this.props.currentLessonQuizList, this.props.unscheduledEventList, auth_id, this.props.companies);
                        this.props.history.push('/course/edit/' + paramHistory.course_id);
                        break;
                    }
                    this.props.saveLesson(this.props.currentLesson, this.props.currentLessonAssignmentList, this.props.currentLessonQuizList, this.props.unscheduledEventList, auth_id, this.props.companies);
                    this.props.history.push('/lesson/list');
                    break;
                }

            case ("edit"):
                {
                    this.props.updateLessonListLoaded(false);
                    this.props.updatePageHeader({ lessonCycleRedirect: true, lessonListIndex: this.props.paramHistory.lessonListIndex + 1 })
                    this.props.saveLesson(this.props.currentLesson, this.props.currentLessonAssignmentList, this.props.currentLessonQuizList, this.props.unscheduledEventList, auth_id, this.props.companies);
                    if (paramActive) {
                        if (paramHistory.completedLessons) {
                            const curIndex = paramHistory.lessonListIndex

                            if (paramHistory.completedLessons.length - 1 === curIndex) {
                                this.props.updatePageHeader({ LessonName: '', lessonCycleActive: false })
                                this.props.clearWizard()
                                this.props.history.push('/course/edit/' + paramHistory.course_id)
                                break;
                            }
                            if (paramHistory.startingPoint === 'lesson') {
                                this.props.updatePageHeader({ LessonName: '', lessonCycleActive: false, active: false })
                                this.props.clearWizard()
                                this.props.history.push('/lesson/list');
                                break;
                            }
                            this.props.updatePageHeader({ LessonName: paramHistory.completedLessons[curIndex + 1].LessonName, lessonListIndex: curIndex + 1, lessonListWeek: paramHistory.completedLessons[curIndex + 1].WeekNum })
                            this.props.history.push('/lesson/edit/' + paramHistory.completedLessons[curIndex + 1].lesson_id)
                            break;
                        }
                        this.props.updatePageHeader({ LessonName: '' })
                        this.props.history.push('/course/edit/' + paramHistory.course_id)
                        break;
                    }
                    else {
                        this.props.history.push('/lesson/list');
                    }
                    break;
                }

            default: { }
        }
    }

    handleDeleteDialogOpen = () => {
        this.setState({ deleteDialogActive: true })
    }

    handleActivateDialogOpen = () => {
        this.setState({ activateDialogActive: true });
    }

    handleActivate = () => {
        this.props.activateLesson(this.props.currentLesson.lesson_id, this.props.auth.user.data.auth_id, this.props.courses);
        this.setState({ activateDialogActive: false });
        return true
    }

    handleDelete = () => {
        const paramHistory = this.props.paramHistory
        const paramActive = paramHistory.active
        switch (this.state.view_type) {
            case ("edit"):
                {
                    this.props.deleteLesson(this.props.currentLesson.lesson_id, paramHistory);

                    if (paramActive) {
                        this.props.updatePageHeader({ LessonName: '', lesson_id: null })
                        this.props.history.push('/course/edit/' + paramHistory.course_id);
                    }
                    else {
                        this.props.history.push('/lesson/list');
                    }
                    break;
                }

            default: { }
        }
    }

    handleLock = () => {
        this.props.lockLesson(this.props.currentLesson.lesson_id, this.props.auth.user.data.auth_id);
        this.setState({ lockDialogActive: false });
        return true
    }

    handleUnlock = () => {
        this.props.unlockLesson(this.props.currentLesson.lesson_id);
        this.setState({ unlockDialogActive: false });
        return true
    }

    getPageContent = (current_tab, view_type) => {
        const { classes,
            currentLesson,
            allAssignments,
            currentLessonAssignmentList,
            allQuizzes,
            currentLessonQuizList,
            unscheduledEventList,
            theme
        } = this.props;

        //map assignments to Calendar event objects
        let used_ids = [];
        currentLessonAssignmentList.forEach((a) => { used_ids.push(a.assignment_id) })
        const events = currentLessonAssignmentList.map((event) => (
            {
                title: event.AssignmentName,
                desc: event.AssignmentDescription,
                start: event.StartTime ? new Date(moment('2018-10-01 ' + event.StartTime).format('YYYY-MM-DD HH:mm:ss')) : null,
                end: event.EndTime ? new Date(moment('2018-10-01 ' + event.EndTime).format('YYYY-MM-DD HH:mm:ss')) : null,
                allDay: false,
                id: event.lesson_assignment_rel_id || 'new_' + event.assignment_id,
                rel_id: event.assignment_id,
                model_id: currentLesson.lesson_id,
                alreadySelected: true,
                eventType: 'assignment',
                Color: event.Color,
                event_id: 'assignment_' + event.assignment_id,
            }
        ));

        const leftCalendarEvents = allAssignments.map((a) => (
            {
                title: a.AssignmentName,
                desc: a.AssignmentDescription,
                start: null,
                end: null,
                allDay: false,
                id: 'new_' + a.assignment_id,
                rel_id: a.assignment_id,
                model_id: currentLesson.lesson_id,
                alreadySelected: used_ids.indexOf(a.assignment_id) > -1,
                eventType: 'assignment',
                Color: a.Color,
                event_id: 'assignment_' + a.assignment_id,
            }
        ))

        //map quizzes to calendar event objects
        let quiz_ids = [];
        currentLessonQuizList.forEach((q) => { quiz_ids.push(q.quiz_id) })
        const quiz_events = currentLessonQuizList.map((event) => (
            {
                title: event.QuizName,
                desc: event.QuizDescription,
                start: event.StartTime ? new Date(moment('2018-10-01 ' + event.StartTime).format('YYYY-MM-DD HH:mm:ss')) : null,
                end: event.EndTime ? new Date(moment('2018-10-01 ' + event.EndTime).format('YYYY-MM-DD HH:mm:ss')) : null,
                allDay: false,
                id: event.lesson_quiz_rel_id || 'new_' + event.quiz_id,
                rel_id: event.quiz_id,
                model_id: currentLesson.lesson_id,
                alreadySelected: true,
                eventType: 'quiz',
                event_id: 'quiz_' + event.quiz_id,
            }
        ))

        const leftCalendarQuizEvents = allQuizzes.map((q) => (
            {
                title: q.QuizName,
                desc: q.QuizDescription,
                start: '',
                end: '',
                allDay: false,
                id: 'new_' + q.quiz_id,
                rel_id: q.quiz_id,
                model_id: currentLesson.lesson_id,
                alreadySelected: quiz_ids.indexOf(q.quiz_id) > -1,
                eventType: 'quiz',
                event_id: 'quiz_' + q.quiz_id,
            }
        ))

        switch (current_tab) {
            case (0): // Detail
                {
                    return (
                        <LessonForm
                            view_type={view_type}
                        />
                    )
                }
            case (1): // Assets
                {
                    return (
                        <ModelAssetList
                            view_type={view_type}
                            model_type='lesson'
                            model_id={this.props.currentLesson.lesson_id}
                            file_type="Lesson File"
                            assetList={this.props.currentLesson.assetList}
                            getAssetList={this.props.getLessonAssetList}
                            updateAssetNameFunc={this.props.updateAssetName}
                        />
                    )
                }
            case (2): // Schedule
                {
                    if (view_type === 'detail') {
                        return (
                            <DetailSchedule dayEvents={events.concat(quiz_events)} currentLesson={this.props.currentLesson} />
                        )
                    }

                    return (
                        <LessonSchedule
                            modelName='lesson'
                            events={events.concat(quiz_events)}
                            currentLessonAssignmentList={currentLessonAssignmentList}
                            currentLessonQuizList={currentLessonQuizList}
                            updateEvent={this.props.updateAssignmentEventTime}
                            eventAddChecker={this.props.checkAssignmentEventAdd}
                            leftItemsAssignment={leftCalendarEvents}
                            leftItemsQuiz={leftCalendarQuizEvents}
                            unscheduledEvents={unscheduledEventList}
                            addUnscheduledEvent={this.props.addUnscheduledEvent}
                            reduxMoveCard={this.props.moveCard}
                            removeEventFromCalendar={this.props.removeEventFromCalendar}
                            prepareDisplayOrders={this.props.prepareDisplayOrders}
                            lesson_id={this.state.lesson_id}
                            paramHistory={this.props.paramHistory}
                            view_type={view_type}
                            currentLesson={this.props.currentLesson}
                            auth_id={this.props.auth.user.data.auth_id}
                            companies={this.props.companies}
                        />
                    )

                }
            case (3):
                {
                    return (
                        <UnscheduledLesson
                            modelName='lesson'
                            events={events.concat(quiz_events)}
                            currentLessonAssignmentList={currentLessonAssignmentList}
                            currentLessonQuizList={currentLessonQuizList}
                            leftItemsAssignment={leftCalendarEvents}
                            leftItemsQuiz={leftCalendarQuizEvents}
                            unscheduledEvents={unscheduledEventList}
                            prepareDisplayOrders={this.props.prepareDisplayOrders}
                            lesson_id={this.state.lesson_id}
                            paramHistory={this.props.paramHistory}
                            view_type={view_type}
                            currentLesson={this.props.currentLesson}
                            auth_id={this.props.auth.user.data.auth_id}
                            companies={this.props.companies}
                        />
                    )
                }
            case (4):
                {
                    return (
                        <LessonEventList
                            assignments={this.props.currentLessonAssignmentList}
                            quizzes={this.props.currentLessonQuizList}
                            unscheduled={this.props.unscheduledEventList}
                            currentLesson={this.props.currentLesson}
                            lesson_id={this.state.lesson_id}
                            view_type={view_type}
                        />
                    )
                }
            case (5): // Prerequisites
                {
                    return (
                        view_type === 'detail' ?
                            <Grid container spacing={24}>
                                <Grid item xs={6}>
                                    <StaticRelationList
                                        rootClass={classes.root}
                                        items={this.props.companies}
                                        header='Companies'
                                    />
                                </Grid>
                            </Grid>
                            :
                            <RelationUpdateTabs
                                currentRelationsTabData={this.props.companies}
                                handleDelete={this.props.toggleCompany}
                                availableObjectList={this.props.allCompanies}
                                handleAdd={this.props.toggleCompany}
                                handleSearchChange={this.handleCompanySearchChange}
                                search={this.props.companySearch}
                                leftHeader="Current Companies"
                                rightHeader="All Companies"
                                view_type={view_type}
                                rootClass={classes.root}
                                dir={theme.direction}
                            />
                    );
                }
            default:
                {
                    return <React.Fragment>Error: No tab found.</React.Fragment>
                }
        }
    }

    getActivateDialog = (active, lesson) => {
        return (
            <Dialog
                open={active}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                onBackdropClick={() => this.setState({ activateDialogActive: false })}
            >
                <DialogTitle>Confirm Activate {lesson.LessonName}?</DialogTitle>
                <DialogContent>
                    {this.props.deleteAllowed ? null :
                        <React.Fragment>
                            <Typography variant="h6">These relations will be Activated</Typography>

                            {this.props.courses.length > 0 ?
                                <React.Fragment>
                                    <Typography variant="h6">Courses</Typography>
                                    <Grid container spacing={8}>
                                        {this.props.courses.map(c => {
                                            return (
                                                <React.Fragment key={c.course_id}>
                                                    {c.conflict ?
                                                        <React.Fragment>
                                                            <Grid item xs={1}>
                                                                <Tooltip
                                                                    style={{ display: 'block' }}
                                                                    title={
                                                                        <React.Fragment>
                                                                            <div>This Course's Lesson will be overwritten</div>
                                                                            <div>{c.conflict[0].LessonName}</div>
                                                                        </React.Fragment>
                                                                    }
                                                                >
                                                                    <Icon>error</Icon>
                                                                </Tooltip>
                                                            </Grid>
                                                            <Grid item xs={11}>
                                                                <Typography variant="body1" >{c.CourseName}</Typography>
                                                            </Grid>
                                                        </React.Fragment>
                                                        :
                                                        <Grid item xs={12}>
                                                            <Typography variant="body1" >{c.CourseName}</Typography>
                                                        </Grid>
                                                    }
                                                </React.Fragment>

                                            )
                                        })}
                                    </Grid>
                                </React.Fragment>
                                : null
                            }

                            {this.props.currentLessonAssignmentList.length > 0 ?
                                <React.Fragment>
                                    <Typography variant="h6">Scheduled Assignments</Typography>
                                    {this.props.currentLessonAssignmentList.map(a => {
                                        return (
                                            <Typography variant="body1" key={a.assignment_id}>{a.AssignmentName}</Typography>
                                        )
                                    })}
                                </React.Fragment>
                                : null
                            }
                            {this.props.currentLessonQuizList.length > 0 ?
                                <React.Fragment>
                                    <Typography variant="h6">Scheduled Quizzes</Typography>
                                    {this.props.currentLessonQuizList.map(q => {
                                        return (
                                            <Typography variant="body1" key={q.quiz_id}>{q.QuizName}</Typography>
                                        )
                                    })}
                                </React.Fragment>
                                : null
                            }
                            {this.props.unscheduledEventList.length > 0 ?
                                <React.Fragment>
                                    <Typography variant="h6">Unscheduled ToDos</Typography>
                                    {this.props.unscheduledEventList.map(e => {
                                        return (
                                            <Typography variant="body1" key={e.id}>{e.title}</Typography>
                                        )
                                    })}
                                </React.Fragment>
                                : null
                            }
                            {this.props.lesson_on_schedule.length > 0 ?
                                <React.Fragment>
                                    <Typography variant="h6">Calendars</Typography>
                                    {this.props.lesson_on_schedule.map(c => {
                                        return (
                                            <Typography variant="body1" key={c.company_calendar_day_id}>{c.CompanyName}</Typography>
                                        )
                                    })}
                                </React.Fragment>
                                : null
                            }
                        </React.Fragment>
                    }
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => this.handleActivate()} color="primary">
                        Activate
                        </Button>
                    <Button onClick={() => this.setState({ activateDialogActive: false })} color="primary" autoFocus>
                        Go Back
                        </Button>
                </DialogActions>
            </Dialog >
        )
    }

    getDeleteDialog = (active, lesson) => {
        return (
            <Dialog
                open={active}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                onBackdropClick={() => this.setState({ deleteDialogActive: false })}
            >
                <DialogTitle>Confirm Deactivate {lesson.LessonName}?</DialogTitle>
                <DialogContent>
                    {this.props.deleteAllowed ? null :
                        <React.Fragment>
                            <Typography variant="h6">The following relationships will be deactivated:</Typography>
                            {this.props.courses.length > 0 ?
                                <React.Fragment>
                                    <Typography variant="h6">Courses</Typography>
                                    {this.props.courses.map(c => {
                                        return (
                                            <Typography variant="body1" key={c.course_id}>{c.CourseName}</Typography>
                                        )
                                    })}
                                </React.Fragment>
                                : null
                            }
                            {this.props.currentLessonAssignmentList.length > 0 ?
                                <React.Fragment>
                                    <Typography variant="h6">Scheduled Assignments</Typography>
                                    {this.props.currentLessonAssignmentList.map(a => {
                                        return (
                                            <Typography variant="body1" key={a.assignment_id}>{a.AssignmentName}</Typography>
                                        )
                                    })}
                                </React.Fragment>
                                : null
                            }
                            {this.props.currentLessonQuizList.length > 0 ?
                                <React.Fragment>
                                    <Typography variant="h6">Scheduled Quizzes</Typography>
                                    {this.props.currentLessonQuizList.map(q => {
                                        return (
                                            <Typography variant="body1" key={q.quiz_id}>{q.QuizName}</Typography>
                                        )
                                    })}
                                </React.Fragment>
                                : null
                            }
                            {this.props.unscheduledEventList.length > 0 ?
                                <React.Fragment>
                                    <Typography variant="h6">Unscheduled ToDos</Typography>
                                    {this.props.unscheduledEventList.map(e => {
                                        return (
                                            <Typography variant="body1" key={e.id}>{e.title}</Typography>
                                        )
                                    })}
                                </React.Fragment>
                                : null
                            }
                            {this.props.lesson_on_schedule.length > 0 ?
                                <React.Fragment>
                                    <Typography variant="h6">Calendars</Typography>
                                    {this.props.lesson_on_schedule.map(c => {
                                        return (
                                            <Typography variant="body1" key={c.company_calendar_day_id}>{c.CompanyName}</Typography>
                                        )
                                    })}
                                </React.Fragment>
                                : null
                            }
                        </React.Fragment>
                    }
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => this.handleDelete()} color="primary">
                        Deactivate
                        </Button>
                    <Button onClick={() => this.setState({ deleteDialogActive: false })} color="primary" autoFocus>
                        Go Back
                        </Button>
                </DialogActions>
            </Dialog>
        )
    }

    getLockDialog = (active) => {
        return (
            <Dialog
                open={active}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                onBackdropClick={() => this.setState({ lockDialogActive: false })}
            >
                <DialogTitle>Lock Lesson?</DialogTitle>
                <DialogContent>
                    Only you and Company Admin level users will be able to edit the lesson.
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => this.handleLock()} color="primary">
                        Lock
                        </Button>
                    <Button onClick={() => this.setState({ lockDialogActive: false })} color="primary" autoFocus>
                        Go Back
                        </Button>
                </DialogActions>
            </Dialog>
        )
    }

    getUnlockDialog = (active) => {
        return (
            <Dialog
                open={active}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                onBackdropClick={() => this.setState({ unlockDialogActive: false })}
            >
                <DialogTitle>Unlock Lesson?</DialogTitle>
                <DialogContent>
                    All company instructors will be able to edit this lesson.
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => this.handleUnlock()} color="primary">
                        Unlock
                        </Button>
                    <Button onClick={() => this.setState({ unlockDialogActive: false })} color="primary" autoFocus>
                        Go Back
                        </Button>
                </DialogActions>
            </Dialog>
        )
    }

    handleBack = () => {
        const paramHistory = this.props.paramHistory
        const paramActive = paramHistory.active

        if (this.props.auth.user.role === 'student') {
            return this.props.history.push('/student/lessons')
        }

        if (!paramActive) {
            return this.props.history.push(`/lesson/list`);
        }


        if (this.props.currentLesson.lesson_id === paramHistory.completedLessons[0].lesson_id) {
            if (this.state.view_type === 'edit') {
                this.props.saveLesson(this.props.currentLesson, this.props.currentLessonAssignmentList, this.props.currentLessonQuizList, this.props.unscheduledEventList);
            }
            this.props.updatePageHeader({ LessonName: '', lessonCycleActive: false });
            return this.props.history.push(`/course/${this.state.view_type}/` + paramHistory.course_id);
        }

        else {
            const targetLesson = paramHistory.completedLessons[paramHistory.lessonListIndex - 1];
            if (this.state.view_type === 'edit') {
                this.props.saveLesson(this.props.currentLesson, this.props.currentLessonAssignmentList, this.props.currentLessonQuizList, this.props.unscheduledEventList);
            }
            this.props.updatePageHeader({ LessonName: targetLesson.LessonName, lessonCycleRedirect: true, lessonListIndex: paramHistory.lessonListIndex - 1, lessonListWeek: targetLesson.WeekNum });
            return this.props.history.push(`/lesson/${this.state.view_type}/` + targetLesson.lesson_id);
        }
    }

    disableSave = () => {
        const { validator } = this.props;
        const { view_type } = this.state

        switch (view_type) {
            case ("edit"): {
                return (
                    validator.map(v => v.error)
                        .includes(true)
                )
            }
            case ('create'): {
                return !(
                    validator.every(v => v.error === false)
                )
            }
        }
    };

    getLockButtonDisplay = () => {
        const role = this.props.auth.user.role;
        const auth_id = this.props.auth.user.data.auth_id;
        // early return if its already locked
        if (this.props.currentLesson.IsLocked === 1) {
            return false;
        }

        if (role === 'dev' || role === 'admin' || role === 'company') {
            return true;
        }
        else if (role === 'instructor' && auth_id === this.props.currentLesson.CreateAuthID) {
            return true;
        }
        return false;
    }

    getUnlockButtonDisplay = () => {
        const role = this.props.auth.user.role;
        const auth_id = this.props.auth.user.data.auth_id;
        // early return if its not locked
        if (this.props.currentLesson.IsLocked === 0) {
            return false;
        }

        if (role === 'dev' || role === 'admin' || role === 'company') {
            return true;
        }
        else if (role === 'instructor' && auth_id === this.props.currentLesson.CreateAuthID) {
            return true;
        }
        return false;
    }

    hideLockedLessonActions = () => {
        const role = this.props.auth.user.role;
        const auth_id = this.props.auth.user.data.auth_id;

        if (this.props.currentLesson.IsLocked === 0) {
            return false;
        }

        if (role === 'dev' || role === 'admin' || role === 'company') {
            return false;
        }
        else if (role === 'instructor' && auth_id === this.props.currentLesson.LockedByAuthID) {
            return false;
        }
        return true;
    }

    createCopy = () => {
        const { currentLesson, auth, currentLessonAssignmentList, currentLessonQuizList, unscheduledEventList, companies } = this.props
        return this.props.saveLessonCopy(
            {
                ...currentLesson,
                LessonName: this.props.NewLessonName,
                lesson_id: 0,
                CopiedFromID: this.props.currentLesson.lesson_id,
            },
            auth.user.data.auth_id,
            currentLessonAssignmentList,
            currentLessonQuizList,
            unscheduledEventList,
            companies
        )
    }

    getCopyDialog = (active) => {
        return (
            <Dialog
                open={active}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                onBackdropClick={() => this.setState({ copyDialogActive: false })}
                fullWidth
                maxWidth={'md'}

            >
                <DialogTitle>Choose a new name</DialogTitle>

                <TextField
                    required
                    id="NewLessonName"
                    label="New Lesson Name"
                    value={this.props.NewLessonName}
                    onChange={(e) => this.props.updateNewLessonName(e.target.value)}
                    {...getSharedTextFieldProps(this.state.view_type, this.props.classes)}
                />

                <DialogActions>
                    <Button onClick={() => this.createCopy(true)} color="primary">
                        Create Copy
                    </Button>

                    <Button onClick={() => this.setState({ copyDialogActive: false })} color="primary" autoFocus>
                        Back
                    </Button>
                </DialogActions>

            </Dialog>
        )
    }

    handleCopyClick = () => {
        this.setState({ copyDialogActive: true })
    }

    render() {
        const { classes, currentLesson, isLessonLoaded } = this.props;
        const { current_tab, view_type } = this.state;
        const delete_dialog = this.getDeleteDialog(this.state.deleteDialogActive, this.props.currentLesson);
        const lock_dialog = this.getLockDialog(this.state.lockDialogActive);
        const unlock_dialog = this.getUnlockDialog(this.state.unlockDialogActive);
        const activate_dialog = this.getActivateDialog(this.state.activateDialogActive, this.props.currentLesson)
        const copy_dialog = this.getCopyDialog(this.state.copyDialogActive)
        const authRole = this.props.auth.user.data.role_info.role_id;

        const deleteTooltipContent =
            <React.Fragment>
                {this.props.currentLessonModuleList.length > 0 ? <h5>Modules depending on this lesson:</h5> : null}
                {this.props.currentLessonModuleList.map(m => {
                    return (
                        <div key={m.module_id}>{m.ModuleName}</div>
                    )
                })}
                {this.props.courses.length > 0 ? <h5>Courses depending on this lesson:</h5> : null}
                {this.props.courses.map(c => {
                    return (
                        <div key={c.course_id}>{c.CourseName}</div>
                    )
                })}
                {this.props.lesson_on_schedule.length > 0 ? <h5>Calendars with this lesson:</h5> : null}
                {this.props.lesson_on_schedule.map(l => {
                    return (
                        <div key={l.company_calendar_day_id}>{l.CompanyName}, Instances: {l.Instances}</div>
                    )
                })}
            </React.Fragment>

        let header_content = (
            <PageHeader
                component_name={currentLesson.LessonName}
                component_type={"lesson"}
                view_type={view_type}
            />
        )
        let headerMargin = false

        if (this.props.paramHistory.active) {
            headerMargin = true
            header_content = <CourseBuilderHeader activeStep={1} baseComponent={'lesson'} companies={this.props.companies}/>
        }
        if (this.props.paramHistory.lessonCycleActive) {
            headerMargin = true
            header_content = <CourseBuilderHeader activeStep={1} baseComponent={'lesson'} companies={this.props.companies}/>
        }

        let page_content = <React.Fragment>Loading...</React.Fragment>;
        if (isLessonLoaded) {
            page_content = this.getPageContent(current_tab, view_type);
        }
        return (
            <FusePageCarded
                classes={{
                    root: classes.layoutRoot,
                    toolbar: classes.layoutToolbar,
                    contentCard: headerMargin ? classes.test : null,
                }}
                header={
                    header_content
                }
                contentToolbar={
                    <div style={{ width: '100%', height: '100%'}}>
                        <Grid container>
                            <Tabs
                                value={current_tab}
                                onChange={this.handleChangeTab}
                                indicatorColor="primary"
                                textColor="primary"
                                classes={{
                                    root: classes.tabsRoot
                                }}
                                scrollable={true}
                            >
                                <Tab
                                    classes={{
                                        root: classes.tabRoot
                                    }}
                                    label="Detail"
                                />
                                <Tab
                                    classes={{
                                        root: classes.tabRoot
                                    }}
                                    label="Asset"
                                // disabled={view_type === 'create'}
                                />
                                <Tab
                                    classes={{
                                        root: classes.tabRoot
                                    }}
                                    label={
                                        "Schedule"
                                    }
                                    disabled={this.props.currentLesson.Unscheduled === 1}
                                />
                                <Tab
                                    classes={{
                                        root: classes.tabRoot
                                    }}
                                    label="Todo List"
                                />
                                <Tab
                                    classes={{
                                        root: classes.tabRoot
                                    }}
                                    label="Event List"
                                // disabled={view_type === 'create'}
                                />
                                <Tab
                                    classes={{
                                        root: classes.tabRoot
                                    }}
                                    label="Company"
                                    // disabled={view_type === 'create'}
                                    hidden={authRole > 2}
                                />
                            </Tabs>
                            <TabPanelButtons
                                component_name={"lesson"}
                                view_type={view_type}
                                button_list={[
                                    {
                                        display: "unlock",
                                        type: "lock",
                                        onClick: this.handleUnlockDialogOpen,
                                        hidden: !this.getUnlockButtonDisplay() || view_type != 'edit'
                                    },
                                    {
                                        display: "lock",
                                        type: "lock",
                                        onClick: this.handleLockDialogOpen,
                                        hidden: !this.getLockButtonDisplay() || view_type != 'edit'
                                    },
                                    {
                                        display: "Save",
                                        type: view_type === 'create' ? 'create' : 'update',
                                        onClick: this.handleSubmit,
                                        disabled: this.disableSave(),
                                        hidden: this.hideLockedLessonActions()
                                    },
                                    {
                                        display: "Copy",
                                        type: "update",
                                        onClick: this.handleCopyClick,
                                        disabled: view_type != 'edit',
                                        hidden: view_type === 'create' || this.props.paramHistory.active
                                    },
                                    {
                                        display: 'deactivate',
                                        type: "delete",
                                        onClick: this.handleDeleteDialogOpen,
                                        largeLabel: true,
                                        // disabled: !this.props.deleteAllowed,
                                        // tooltip: { active: !this.props.deleteAllowed, content: deleteTooltipContent },
                                        hidden: this.hideLockedLessonActions() || this.props.currentLesson.Active === 0
                                    },
                                    {
                                        type: "activate",
                                        largeLabel: true,
                                        onClick: this.handleActivateDialogOpen,
                                        // disabled: !this.props.deleteAllowed,
                                        hidden: this.hideLockedLessonActions() || this.props.currentLesson.Active === 1,
                                        

                                    },
                                    {
                                        type: "back",
                                        onClick: this.handleBack,
                                    }
                                ]}
                            />
                        </Grid>
                    </div>
                }
                content={
                    <React.Fragment>
                        <div className="p-24">
                            {unlock_dialog}
                            {lock_dialog}
                            {delete_dialog}
                            {copy_dialog}
                            {page_content}
                            {activate_dialog}
                        </div>
                    </React.Fragment>
                }
            />
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getLesson: Actions.getLesson,
        getLessonData: Actions.getLessonData,
        updateLessonLoaded: Actions.updateLessonLoaded,
        saveSchedule: Actions.saveSchedule,
        updateAssignmentEventTime: Actions.updateAssignmentEventTime,
        checkAssignmentEventAdd: Actions.checkAssignmentEventAdd,
        addUnscheduledEvent: Actions.addUnscheduledEvent,
        moveCard: Actions.moveCard,
        removeEventFromCalendar: Actions.removeEventFromCalendar,
        prepareDisplayOrders: Actions.prepareDisplayOrders,
        saveLesson: Actions.saveLesson,
        deleteLesson: Actions.deleteLesson,
        updateLessonForm: Actions.updateLessonForm,
        getLessonAssetList: Actions.getLessonAssetList,
        getAllQuizzes: Actions.getAllQuizzes,
        getAllAssignments: Actions.getAllAssignments,
        startValidator: validatorActions.startValidator,
        updatePageHeader: paramActions.updateCourseBuilderParams,
        clearWizard: courseActions.clearWizard,
        lockLesson: Actions.lockLesson,
        unlockLesson: Actions.unlockLesson,
        toggleCompany: Actions.toggleCompany,
        companyUpdateSearch: Actions.companyUpdateSearch,
        updateLessonListLoaded: Actions.updateLessonListLoaded,
        getCompanyList: Actions.getCompanyList,
        activateLesson: Actions.activateLesson,
        updateAssetName: Actions.updateAssetName,
        saveLessonCopy: Actions.saveLessonCopy,
        toggleLessonRepull: Actions.toggleLessonRepull,
        updateNewLessonName: Actions.updateNewLessonName
    }, dispatch);
}

function mapStateToProps({ lessonApp, auth, validator, paramHistory }) {
    return {
        currentLesson: lessonApp.lessons.currentLesson,
        isLessonLoaded: lessonApp.lessons.isLessonLoaded,
        allQuizzes: lessonApp.lessons.allQuizzes,
        allAssignments: lessonApp.lessons.allAssignments,
        currentLessonAssignmentList: lessonApp.lessons.currentLessonAssignmentList,
        currentLessonQuizList: lessonApp.lessons.currentLessonQuizList,
        currentLessonModuleList: lessonApp.lessons.currentLessonModuleList,
        companies: lessonApp.lessons.companies,
        allCompanies: lessonApp.lessons.allCompanies,
        unscheduledEventList: lessonApp.lessons.unscheduledEventList,
        allEventList: lessonApp.lessons.allEventList,
        courses: lessonApp.lessons.courses,
        deleteAllowed: lessonApp.lessons.deleteAllowed,
        lesson_on_schedule: lessonApp.lessons.lesson_on_schedule,
        validator: validator.list,
        paramHistory: paramHistory.courseBuilder,
        companySearch: lessonApp.lessons.companySearch,
        NewLessonName: lessonApp.lessons.NewLessonName,
        repullLesson: lessonApp.lessons.repullLesson,
        auth,
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(Lesson)));



// WEBPACK FOOTER //
// src/main/content/lesson/Lesson.js